import { createFileRoute } from '@tanstack/react-router'
import Events from 'Integration/components/webhooks/Events'

export const Route = createFileRoute('/integrations/_webhooks/webhook/events')({
    component: Events,
})
